import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as c from "react";
import { u as S } from "./index.B4ZV02se.js";
import { c as z, u as H, a as N } from "./index.stoqs9MZ.js";
import { u as G } from "./index.BZPx6jYI.js";
import { u as K } from "./index.CD933GbG.js";
import { P as U } from "./index.TrmYLGk6.js";
import { P } from "./index.DMLWxr4u.js";
import { c as W } from "./index.C4-GUKyp.js";
import { F as X } from "./Check16.D3hXRfGO.js";
import { c as g } from "./index.CxSWpsOB.js";
import { L as V } from "./Label.h3I9kFDT.js";
var y = "Checkbox", [$, pe] = z(y), [J, E] = $(y);
function Q(t) {
  const {
    __scopeCheckbox: o,
    checked: s,
    children: i,
    defaultChecked: n,
    disabled: e,
    form: l,
    name: f,
    onCheckedChange: d,
    required: b,
    value: x = "on",
    // @ts-expect-error
    internal_do_not_use_render: p
  } = t, [m, C] = H({
    prop: s,
    defaultProp: n ?? !1,
    onChange: d,
    caller: y
  }), [k, w] = c.useState(null), [v, a] = c.useState(null), u = c.useRef(!1), R = k ? !!l || !!k.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), j = {
    checked: m,
    disabled: e,
    setChecked: C,
    control: k,
    setControl: w,
    name: f,
    form: l,
    value: x,
    hasConsumerStoppedPropagationRef: u,
    required: b,
    defaultChecked: h(n) ? !1 : n,
    isFormControl: R,
    bubbleInput: v,
    setBubbleInput: a
  };
  return /* @__PURE__ */ r.jsx(
    J,
    {
      scope: o,
      ...j,
      children: Y(p) ? p(j) : i
    }
  );
}
var B = "CheckboxTrigger", F = c.forwardRef(
  ({ __scopeCheckbox: t, onKeyDown: o, onClick: s, ...i }, n) => {
    const {
      control: e,
      value: l,
      disabled: f,
      checked: d,
      required: b,
      setControl: x,
      setChecked: p,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: C,
      bubbleInput: k
    } = E(B, t), w = S(n, x), v = c.useRef(d);
    return c.useEffect(() => {
      const a = e?.form;
      if (a) {
        const u = () => p(v.current);
        return a.addEventListener("reset", u), () => a.removeEventListener("reset", u);
      }
    }, [e, p]), /* @__PURE__ */ r.jsx(
      P.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": h(d) ? "mixed" : d,
        "aria-required": b,
        "data-state": A(d),
        "data-disabled": f ? "" : void 0,
        disabled: f,
        value: l,
        ...i,
        ref: w,
        onKeyDown: N(o, (a) => {
          a.key === "Enter" && a.preventDefault();
        }),
        onClick: N(s, (a) => {
          p((u) => h(u) ? !0 : !u), k && C && (m.current = a.isPropagationStopped(), m.current || a.stopPropagation());
        })
      }
    );
  }
);
F.displayName = B;
var _ = c.forwardRef(
  (t, o) => {
    const {
      __scopeCheckbox: s,
      name: i,
      checked: n,
      defaultChecked: e,
      required: l,
      disabled: f,
      value: d,
      onCheckedChange: b,
      form: x,
      ...p
    } = t;
    return /* @__PURE__ */ r.jsx(
      Q,
      {
        __scopeCheckbox: s,
        checked: n,
        defaultChecked: e,
        disabled: f,
        required: l,
        onCheckedChange: b,
        name: i,
        form: x,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(
            F,
            {
              ...p,
              ref: o,
              __scopeCheckbox: s
            }
          ),
          m && /* @__PURE__ */ r.jsx(
            q,
            {
              __scopeCheckbox: s
            }
          )
        ] })
      }
    );
  }
);
_.displayName = y;
var L = "CheckboxIndicator", M = c.forwardRef(
  (t, o) => {
    const { __scopeCheckbox: s, forceMount: i, ...n } = t, e = E(L, s);
    return /* @__PURE__ */ r.jsx(
      U,
      {
        present: i || h(e.checked) || e.checked === !0,
        children: /* @__PURE__ */ r.jsx(
          P.span,
          {
            "data-state": A(e.checked),
            "data-disabled": e.disabled ? "" : void 0,
            ...n,
            ref: o,
            style: { pointerEvents: "none", ...t.style }
          }
        )
      }
    );
  }
);
M.displayName = L;
var T = "CheckboxBubbleInput", q = c.forwardRef(
  ({ __scopeCheckbox: t, ...o }, s) => {
    const {
      control: i,
      hasConsumerStoppedPropagationRef: n,
      checked: e,
      defaultChecked: l,
      required: f,
      disabled: d,
      name: b,
      value: x,
      form: p,
      bubbleInput: m,
      setBubbleInput: C
    } = E(T, t), k = S(s, C), w = G(e), v = K(i);
    c.useEffect(() => {
      const u = m;
      if (!u) return;
      const R = window.HTMLInputElement.prototype, I = Object.getOwnPropertyDescriptor(
        R,
        "checked"
      ).set, D = !n.current;
      if (w !== e && I) {
        const O = new Event("click", { bubbles: D });
        u.indeterminate = h(e), I.call(u, h(e) ? !1 : e), u.dispatchEvent(O);
      }
    }, [m, w, e, n]);
    const a = c.useRef(h(e) ? !1 : e);
    return /* @__PURE__ */ r.jsx(
      P.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: l ?? a.current,
        required: f,
        disabled: d,
        name: b,
        value: x,
        form: p,
        ...o,
        tabIndex: -1,
        ref: k,
        style: {
          ...o.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
q.displayName = T;
function Y(t) {
  return typeof t == "function";
}
function h(t) {
  return t === "indeterminate";
}
function A(t) {
  return h(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
const Z = W("tw-bg-base-white tw-inline-flex tw-items-center tw-justify-center tw-rounded-2 tw-border tw-border-gray-400 tw-size-16 tw-align-text-top tw-peer tw-shrink-0 tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-800 focus-visible:tw-ring-offset-1 disabled:tw-pointer-events-none disabled:tw-bg-gray-300 data-[state=checked]:tw-bg-gray-900 data-[state=checked]:tw-border-gray-900 data-[state=checked]:tw-text-base-white", {
  variants: {
    alignment: {
      top: "tw-mt-4",
      // accounts for label line-height
      center: ""
    }
  }
}), ee = ({
  children: t,
  errorMsg: o
}) => /* @__PURE__ */ r.jsx("div", { className: g("tw-p-16 tw-bg-gray-100 tw-border tw-border-gray-300 tw-rounded-4", {
  "tw-border-red-800": !!o
}), children: t }), te = c.forwardRef(({
  description: t,
  className: o,
  testId: s,
  alignment: i = "center",
  errorMsg: n,
  variant: e = "default",
  ...l
}, f) => {
  const d = e === "box" ? ee : c.Fragment, b = e === "box" ? {
    errorMsg: n
  } : {};
  return /* @__PURE__ */ r.jsx(d, { ...b, children: /* @__PURE__ */ r.jsxs("div", { className: g("tw-inline-flex tw-items-center tw-gap-8 tw-relative", {
    "tw-items-start": i === "top"
  }), children: [
    /* @__PURE__ */ r.jsx(_, { ref: f, className: g(Z({
      className: o,
      alignment: i
    })), "data-testid": s, ...l, children: /* @__PURE__ */ r.jsx(M, { className: g("tw-flex tw-items-center tw-justify-center tw-text-current"), children: /* @__PURE__ */ r.jsx(X, {}) }) }),
    t && /* @__PURE__ */ r.jsx(V, { className: "tw-body-2 tw-cursor-pointer", htmlFor: l.id, children: t })
  ] }) });
});
te.displayName = _.displayName;
export {
  te as C
};
//# sourceMappingURL=Checkbox.PFuVDlpI.js.map
